import {KeyLabel} from './key-label.model';
export enum OnboardingStage {
  QUALIFICATION = 'QUALIFICATION',
  CONTRACT = 'CONTRACT',
  IO_EXECUTED = 'IO_EXECUTED',
  LOGIN_EMAIL = 'LOGIN_EMAIL',
  PRODUCTION = 'PRODUCTION',
  GO_LIVE = 'GO_LIVE',
  ONBOARDING_FINISHED = 'ONBOARDING_FINISHED'
}

export enum OnboardingStageOrder {
  QUALIFICATION = 1,
  CONTRACT = 2,
  IO_EXECUTED = 3,
  LOGIN_EMAIL = 4,
  PRODUCTION = 5,
  GO_LIVE = 6,
  ONBOARDING_FINISHED = 7
}

export const OnboardingStageLabels = {
  QUALIFICATION: 'Site Approval',
  CONTRACT: 'Proposal',
  IO_EXECUTED: 'Finance',
  LOGIN_EMAIL: 'Kickoff call',
  PRODUCTION: 'Production',
  GO_LIVE: 'Go live',
  ONBOARDING_FINISHED: 'Live'
};

export const OnboardingStageKL = () => {
  return Object.keys(OnboardingStage).map(key => new KeyLabel(key, OnboardingStageLabels[key]));
};

